import { useMemo } from "react";
import { useReturnRequestsFilters } from "../../providers/use-return-requests-filters";
import { isDateFilterName } from "../utils/check-filter-type";
import { Filter, StringFilterValue } from "../utils/types";

export function useReturnRequestsSerializedFilter() {
  const { filters: filtersMap } = useReturnRequestsFilters();

  const filter: object = useMemo(() => {
    return Array.from(filtersMap.entries()).reduce<Partial<Filter>>(
      (acc, [name, filter]) => {
        if (isDateFilterName(name)) {
          acc[name] = {
            condition: filter.condition,
            value: filter.value,
          };
        } else {
          acc[name] = {
            condition: filter.condition,
            value: filter.value,
          } as StringFilterValue;
        }
        return acc;
      },
      {},
    );
  }, [filtersMap]);

  return filter;
}
